module.exports = __webpack_public_path__ + "img/inventory-bulk-update.21213a2a.png";